module.exports = __webpack_public_path__ + "static/2-b52664719534fad176c5cb7f6c61d66a.png";